import { MobileSdkTestSummaryQueryVariables } from '../MobileSdkTestSummary.generated';

export const buildMobileSdkTestSummaryQueryVariables = (
	testId: string
): MobileSdkTestSummaryQueryVariables => {
	return {
		runId: {
			value: [testId]
		}
	};
};
